// Splits plain text into text and http(s) URL parts. Pure function, no HTML is ever produced.
const URL_RE = /https?:\/\/[^\s<>]+/gi;
const TRAILING = /[.,;:!?'"’”\]}>]$/;

// Trailing punctuation is not part of the URL; a closing ")" only when it has no opening "(" in the URL.
function trimUrl(url) {
  for (;;) {
    if (TRAILING.test(url)) url = url.slice(0, -1);
    else if (url.endsWith(")") && (url.match(/\(/g) || []).length < (url.match(/\)/g) || []).length) url = url.slice(0, -1);
    else return url;
  }
}

export function splitLinks(text) {
  const str = text == null ? "" : String(text);
  const parts = [];
  let last = 0;
  for (const m of str.matchAll(URL_RE)) {
    const url = trimUrl(m[0]);
    if (!/^https?:\/\/[^/?#]/i.test(url)) continue;
    if (m.index > last) parts.push({ text: str.slice(last, m.index) });
    parts.push({ text: url, url });
    last = m.index + url.length;
  }
  if (last < str.length) parts.push({ text: str.slice(last) });
  return parts;
}
